export default __webpack_public_path__ + "static/media/arrow-up.ffcae711.svg";